import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/swiper-bundle.css'

export function render () {

  const el = document.querySelector('.c-gallery__slider')
  if (!el) return

  new Swiper(el, {
    modules: [Navigation, Pagination],
    slidesPerView: 1.15,
    centeredSlides: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.c-gallery__nav.-next',
      prevEl: '.c-gallery__nav.-prev',
    },
    pagination: {
      el: '.c-gallery__pagination',
      clickable: true,
    },
    breakpoints: {
      768: { slidesPerView: 2, centeredSlides: false, spaceBetween: 30 },
      1024: { slidesPerView: 3, centeredSlides: false, spaceBetween: 30 },
    },
  })

}
